import React, { useEffect } from 'react';
import styled from 'styled-components';
import Loading from '../components/Loading';
import { API_HOST } from '../consts';
import Axios from 'axios';
import { withRouter } from 'react-router-dom';

const ExternalAuthV3Page = ({ className, match, history }) => {
  const { token, redirect } = match.params;

  const handleExternalLogin = () => {
    Axios.post(`${API_HOST}/external-auth/signinV3`, {token})
    .then((response) => {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('iframe', JSON.stringify(true));
      history.push(`/${atob(redirect)}`);
    });
  };

  useEffect(() => {
    handleExternalLogin();
  }, []);

  return <Loading />;
};
export default styled(withRouter(ExternalAuthV3Page))`
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  flex-direction: column;
  p {
    margin-top: 0.5rem;
    font-weight: bold;
  }
`;
